import { render, staticRenderFns } from "./MobileImportantComponent.vue?vue&type=template&id=84db5e2a&lang=pug&"
var script = {}
import style0 from "./MobileImportantComponent.vue?vue&type=style&index=0&id=84db5e2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports